"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentFunctionBoundarySchema = void 0;
const zod_1 = require("zod");
const IComponentFunctionBoundaryDefinition_1 = require("./IComponentFunctionBoundaryDefinition");
const IModeCondition_1 = require("../DesignModels/IModeCondition");
exports.IComponentFunctionBoundarySchema = zod_1.z.object({
    id: zod_1.z.string(),
    globlal: zod_1.z.boolean().optional(),
    conditions: zod_1.z.lazy(() => IModeCondition_1.IModeConditionSchema.array().optional()),
    boundary: zod_1.z.lazy(() => IComponentFunctionBoundaryDefinition_1.IComponentFunctionBoundaryDefinitionSchema),
});
//# sourceMappingURL=IComponentFunctionBoundary.js.map